// extracted by mini-css-extract-plugin
export var bubble = "_33-0";
export var container = "_33-3";
export var contrastBorder = "_33-4";
export var greyOut = "_33-2";
export var initialsWrapper = "_33-1";
export var large = "_33-9";
export var medium = "_33-8";
export var mediumSmall = "_33-7";
export var mediumSmallMedium = "_33-c";
export var micro = "_33-5";
export var small = "_33-6";
export var tiny = "_33-b";
export var xTiny = "_33-a";